import React from 'react';
import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../../../Services/AppContext';
import { loadDOMComponent } from '../../../../helpers';
import { store } from '../../../../store/store';
import { Provider } from 'react-redux';
import { parseBoolean } from '../../../../Utils/form.util';
import CanCreateCase from './CanCreateCase';

loadDOMComponent({
	selector: 'react-can-create-case',
	callback: ({ container, context, props }: any) => {
		const text1: string | undefined =
			container.getAttribute('data-text1') || undefined;
		const text2 = container.getAttribute('data-text2') || undefined;
		const text3 = container.getAttribute('data-text3') || undefined;
		const canChangeEmail = parseBoolean(
			container.getAttribute('data-canChangeEmail'),
		);
		const changeEmailButtonLabel =
			container.getAttribute('data-changeEmailButtonLabel') || undefined;
		const userEmail = container.getAttribute('data-user-email') || undefined;

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<CanCreateCase
						text1={text1}
						text2={text2}
						text3={text3}
						canChangeEmail={canChangeEmail}
						changeEmailButtonLabel={changeEmailButtonLabel}
						userEmail={userEmail}
					/>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
